<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="dimensions.Label">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ dimensions.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="dimensions.Length !== null">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdimensions.length' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ dimensions.Length }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="dimensions.Width !== null">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdimensions.width' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ dimensions.Width }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="dimensions.Height !== null">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdimensions.height' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ dimensions.Height }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="dimensions.Units && dimensions.Units >= 0">
    <td class="th-plugin-line--subheader">
      <span>
        <strong>{{ 'plugins.installationdimensions.units' | translate }}</strong>
      </span>
    </td>
    <td>
      <p>
        <span class="ir-ph1">{{ dimensions.Units | measuringunits }}</span>
      </p>
    </td>
  </tr>
</table>
